import { Modal, ModalProps, Typography } from 'antd';
import styled from 'styled-components';
import { COLORS, FONT_WEIGHTS, TEXT_SIZES } from '../../utils/constants';
import { CloseCircleOutlined } from '@ant-design/icons';
import Button from '../common/Button';

interface DeleteModalProps extends ModalProps {
  open: boolean;
  moduleType: string;
  body?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteModal = ({
  open,
  moduleType,
  body,
  loading,
  onCancel,
  onConfirm,
}: DeleteModalProps) => {
  return (
    <StyledModal
      title={`Delete ${moduleType}`}
      open={open}
      width={635}
      onCancel={onCancel}
      centered
      closeIcon={
        <CloseCircleOutlined
          style={{ color: COLORS.white.primary, fontSize: TEXT_SIZES.XXL }}
        />
      }
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button key="delete" type="primary" danger onClick={onConfirm} loading={loading}>
          Delete {moduleType}
        </Button>,
      ]}
    >
      <ContentWrapper>
        <WarningText>
          Are you sure you want to permanently delete this {body ? body : moduleType}?
        </WarningText>
        <WarningText>This action cannot be undone.</WarningText>
      </ContentWrapper>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-content {
    overflow: hidden;
    padding: 0px;
  }
  .ant-modal-header {
    background: ${COLORS.red.primary};
    margin-bottom: 24px;
    padding: 16px 24px;
  }
  .ant-modal-title {
    color: ${COLORS.white.primary} !important;
    font-size: ${TEXT_SIZES.LG};
    font-weight: ${FONT_WEIGHTS.REGULAR};
  }
  .ant-modal-footer {
    padding: 16px 24px 24px 24px;
  }
`;

const ContentWrapper = styled.div`
  padding: 0px 24px;
`;

const WarningText = styled(Typography.Text)`
  display: block;
  font-size: ${TEXT_SIZES.SM}px;
`;

export default DeleteModal;
